import { render, staticRenderFns } from "./GlobalAddressRegistry.vue?vue&type=template&id=9f113e92&scoped=true&"
import script from "./GlobalAddressRegistry.vue?vue&type=script&lang=js&"
export * from "./GlobalAddressRegistry.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAddressRegistry.vue?vue&type=style&index=0&id=9f113e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f113e92",
  null
  
)

/* custom blocks */
import block0 from "./GlobalAddressRegistry.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports